import type { CategoryId, SessionData } from "../types";
import { categories } from "../data/platforms";
import { formatRelativeTime } from "../lib/format";
import { Icon } from "./Icon";

interface HeaderProps {
  query: string;
  category: "all" | CategoryId;
  updatedAt: string | null;
  refreshing: boolean;
  session: SessionData | null;
  authChecking: boolean;
  onQueryChange: (value: string) => void;
  onCategoryChange: (value: "all" | CategoryId) => void;
  onOpenMenu: () => void;
  onOpenLibrary: (tab: "favorites" | "history") => void;
  onOpenAuth: () => void;
  onOpenAccount: () => void;
  onRefresh: () => void;
}

export function Header({
  query,
  category,
  updatedAt,
  refreshing,
  session,
  authChecking,
  onQueryChange,
  onCategoryChange,
  onOpenMenu,
  onOpenLibrary,
  onOpenAuth,
  onOpenAccount,
  onRefresh,
}: HeaderProps) {
  return (
    <header className="topbar">
      <div className="topbar-main">
        <button className="icon-button mobile-only" aria-label="打开平台菜单" onClick={onOpenMenu} type="button">
          <Icon name="menu" />
        </button>
        <div className="mobile-brand mobile-only" aria-label="今日聚合">
          <span aria-hidden="true">聚</span>
          <strong>今日聚合</strong>
        </div>
        <label className="search-box">
          <Icon name="search" />
          <input
            aria-label="搜索当前榜单"
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="搜索当前榜单"
            type="search"
            value={query}
          />
          {query ? (
            <button aria-label="清空搜索" onClick={() => onQueryChange("")} type="button">
              <Icon name="close" />
            </button>
          ) : null}
        </label>

        <div className="topbar-actions">
          <span className="update-indicator" title={updatedAt || "尚未完成采集"}>
            <span className="status-dot" />
            {formatRelativeTime(updatedAt)}
          </span>
          <button className={`icon-button ${refreshing ? "is-spinning" : ""}`} aria-label="刷新榜单" onClick={onRefresh} type="button">
            <Icon name="refresh" />
          </button>
          <button className="icon-button desktop-action" aria-label="查看收藏" onClick={() => onOpenLibrary("favorites")} type="button">
            <Icon name="bookmark" />
          </button>
          <button className="icon-button desktop-action" aria-label="查看浏览记录" onClick={() => onOpenLibrary("history")} type="button">
            <Icon name="clock" />
          </button>
          <span className="local-mode">{session ? "云端已同步" : "访客 · 本地保存"}</span>
          <button
            className="account-button"
            disabled={authChecking}
            onClick={session ? onOpenAccount : onOpenAuth}
            type="button"
          >
            <span className="account-avatar">{session ? session.user.name.slice(0, 1).toUpperCase() : <Icon name="user" />}</span>
            <span>{authChecking ? "检查中" : session ? session.user.name : "登录"}</span>
          </button>
        </div>
      </div>

      <nav className="category-tabs" aria-label="内容分类">
        {categories.map((item) => (
          <button
            className={category === item.id ? "is-active" : ""}
            key={item.id}
            onClick={() => onCategoryChange(item.id)}
            type="button"
          >
            {item.label}
          </button>
        ))}
      </nav>
    </header>
  );
}
